import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Printer } from "lucide-react";
import { api, fmtDate, errMsg } from "../lib/api";

export default function Certificate() {
  const { no } = useParams();
  const [cert, setCert] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => { api.get(`/certificates/${no}`).then((r) => setCert(r.data)).catch((e) => setError(errMsg(e))); }, [no]);

  if (error) return <div className="min-h-screen grid place-items-center text-[#5B2A6E]" data-testid="certificate-error">{error}</div>;
  if (!cert) return <div className="min-h-screen grid place-items-center">Loading…</div>;

  return (
    <div className="min-h-screen bg-[#FAF8FC] py-10 px-4">
      <div className="no-print max-w-4xl mx-auto flex justify-between mb-4">
        <Link to="/app/academy" className="dx-btn-ghost" data-testid="certificate-back-link">Back</Link>
        <button className="dx-btn-purple" onClick={() => window.print()} data-testid="certificate-print-btn"><Printer className="w-4 h-4" />Print / Save PDF</button>
      </div>
      <div className="max-w-4xl mx-auto bg-white border-[10px] border-[#5B2A6E] p-2" data-testid="certificate-card">
        <div className="border-2 border-[#D4AF37] px-6 sm:px-14 py-12 text-center">
          <img src="/brand/logo.png" alt="Dexterity Consult" className="w-20 h-20 object-contain mx-auto" />
          <div className="font-serif-dx text-2xl tracking-[0.3em] text-[#5B2A6E] mt-5">DEXTERITY CONSULT</div>
          <div className="text-xs tracking-[0.25em] text-[#8a7a92] uppercase">Consultants · Engineers · Strategists</div>
          <div className="text-sm uppercase tracking-[0.3em] text-[#D4AF37] font-bold mt-10">Certificate of Achievement</div>
          <p className="text-[#6b5a73] mt-6">This certifies that</p>
          <div className="font-serif-dx italic text-4xl sm:text-5xl text-[#250E31] mt-3" data-testid="certificate-name">{cert.name}</div>
          <p className="text-[#6b5a73] mt-6">has successfully completed the training and examination for</p>
          <div className="font-display text-2xl sm:text-3xl font-bold text-[#5B2A6E] mt-3" data-testid="certificate-course">{cert.course_title} ({cert.code})</div>
          <div className="grid grid-cols-3 gap-4 mt-12 text-sm">
            <div><div className="text-[#8a7a92] text-xs uppercase tracking-wider">Date</div><div className="font-semibold mt-1">{fmtDate(cert.completed_at)}</div></div>
            <div><div className="text-[#8a7a92] text-xs uppercase tracking-wider">Score</div><div className="font-semibold mt-1">{cert.score}%</div></div>
            <div><div className="text-[#8a7a92] text-xs uppercase tracking-wider">Certificate no.</div><div className="font-semibold mt-1 break-all" data-testid="certificate-number">{cert.certificate_no}</div></div>
          </div>
          <p className="text-xs text-[#8a7a92] mt-10">Verify at {window.location.origin}/certificate/{cert.certificate_no}</p>
        </div>
      </div>
    </div>
  );
}
